import zhTw from '@/i18n/zh-TW/index';

export default {
  zhTw
};
